import React, {useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {
  getInterviewbyid,
  getResponseByInterviewAndAnswer,
  editInterviewResponse,
  getCountries,
} from '../_requets'
import {debounce} from 'lodash'
import Flatpickr from 'react-flatpickr'
import 'flatpickr/dist/flatpickr.css'
import {RootState} from '../../../redux/store'
import {useSelector, useDispatch} from 'react-redux'
import {setCountries} from '../../../redux/utils/countrySlice'
import Swal from 'sweetalert2'
import PlacesAutocomplete, {geocodeByAddress, getLatLng} from 'react-places-autocomplete'
import {KTIcon} from '../../../../_metronic/helpers'
import {GoogleMap, Marker} from '@react-google-maps/api'
import {Button, Modal, Spinner} from 'react-bootstrap'
import Select from 'react-select'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import {parseBold, removeAsterisk} from '../../../utils/parseText'

interface QuestionData {
  title?: string
  titleId?: string
  questionId?: string
  question: string
  type: string
  order: number
  required: boolean
  other: boolean
  comment: boolean
  options: string[]
  reason: boolean
  reasonTitle?: string
  reasonType?: string
  reasonOptions?: string[]
  checkpointId?: string
}

interface InterviewQuestion extends Omit<QuestionData, 'options' | 'reasonOptions' | 'comment'> {
  response: any[]
  comment: string
  reasonResponse: any[]
  coordinates?: {lat: number; lng: number}
}

interface SectionOption {
  option: string
  from: number
  to: number
}

const TimeIntervals = ({interval = 15, index, questions, setQuestions, isReason = false}) => {
  return (
    <div>
      <DatePicker
        selected={
          isReason
            ? questions[index]?.reasonResponse?.[0]
              ? new Date(questions[index].reasonResponse[0])
              : new Date()
            : questions[index]?.response?.[0]
            ? new Date(questions[index].response[0])
            : new Date()
        }
        onChange={(date) => {
          setQuestions((prev) => {
            const updatedFormData = [...prev]
            if (isReason) {
              updatedFormData[index] = {
                ...updatedFormData[index],
                reasonResponse: [date],
              }
            } else {
              updatedFormData[index] = {
                ...updatedFormData[index],
                response: [date],
              }
            }
            return updatedFormData
          })
        }}
        showTimeSelect
        showTimeSelectOnly
        timeIntervals={interval}
        dateFormat='h:mm aa'
        className='form-control'
      />
    </div>
  )
}

const EditInterviewQuestionaire: React.FC = () => {
  const params = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {countries, loading: countryLoading} = useSelector((state: RootState) => state.country)
  const [validateInput, setValidateInput] = useState(false)
  const [data, setData] = useState([])
  const [interviewName, setInterviewName] = useState('')
  const [projectName, setProjectName] = useState('')
  const [questions, setQuestions] = useState<any>([
    {
      title: '',
      titleId: '',
      questionId: '',
      question: '',
      type: '',
      response: [],
      comment: '',
      reasonType: '',
      reasonTitle: '',
      reasonResponse: [],
    },
  ])
  const [locationName, setLocationName] = useState([])
  const [reasonLocationName, setReasonLocationName] = useState([])
  const [bool, setBool] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [coordinates, setCoordinates] = useState<{lat: number; lng: number} | null>(null)
  const [selectedIndex, setSelectedIndex] = useState(null)
  const [submitting, setSubmitting] = useState(false)
  const [checkpoints, setCheckpoints] = useState<
    {index: number; sectionOptions: SectionOption[]}[]
  >([])
  const [skippedQuestionsIndex, setSkippedQuestionsIndex] = useState<number[]>([])
  const [questionNumberList, setQuestionNumberList] = useState<number[]>([])

  const [center, setCenter] = useState({
    lat: 25.276987,
    lng: 55.296249,
  })

  const mapContainerStyle = {
    width: '100%',
    height: '400px',
  }

  const closeModal = () => {
    setCoordinates(null)
    setShowModal(false)
  }

  const saveLocation = () => {
    if (coordinates) {
      setQuestions((prev) => {
        const currentIndex = bool.findIndex((b) => b === true)
        if (currentIndex !== -1) {
          const updatedFormData = [...prev]
          updatedFormData[currentIndex] = {
            ...updatedFormData[currentIndex],
            coordinates: coordinates,
          }
          return updatedFormData
        }
        return prev
      })
    }
    setShowModal(false)
  }

  const handleMapClick = (event: any) => {
    setCoordinates({
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
    })
    setLocationName((prev) => {
      const updatedLocationName = [...prev]
      updatedLocationName[selectedIndex] = ''
      return updatedLocationName
    })
    setQuestions((prev) => {
      const updatedFormData = [...prev]
      updatedFormData[selectedIndex] = {
        ...updatedFormData[selectedIndex],
        coordinates: {
          lat: event.latLng.lat(),
          lng: event.latLng.lng(),
        },
      }
      return updatedFormData
    })
    setBool(Array(questions.length).fill(false))
  }

  // Function to calculate question numbers and skipped indices
  const calculateQuestionDisplayInfo = (
    allQuestions: QuestionData[],
    allCheckpoints: typeof checkpoints,
    currentQuestionResponses: any[]
  ): {questionNumberList: number[]; skippedQuestionsIndex: number[]} => {
    let currentSkippedOrders: number[] = []

    const checkpointOrders = allCheckpoints.map((cp) => cp.index + 1)

    allCheckpoints.forEach((cp) => {
      const checkpointQuestionIndex = allQuestions.findIndex(
        (q) => q.order === cp.index + 1 && q.type === 'checkpoint'
      )

      if (checkpointQuestionIndex !== -1) {
        const checkpointResponseValue =
          currentQuestionResponses[checkpointQuestionIndex]?.response?.[0]
        const allOrdersAfterCheckpoint = allQuestions
          .filter((q) => q.order - 1 > cp.index)
          .map((q) => q.order)

        let ordersToKeep: number[] = []
        const selectedOption = cp.sectionOptions.find(
          (opt) => opt.option === checkpointResponseValue
        )

        if (selectedOption) {
          for (let order = selectedOption.from; order <= selectedOption.to; order++) {
            ordersToKeep.push(order)
          }
        }

        const ordersToSkipFromThisCheckpoint = allOrdersAfterCheckpoint.filter((order) => {
          const isCheckpointQuestion = checkpointOrders.includes(order)
          if (isCheckpointQuestion) {
            return false
          }
          const isInKeepRange = ordersToKeep.includes(order)
          return !isInKeepRange
        })

        ordersToKeep.forEach((order) => {
          if (currentSkippedOrders.includes(order)) {
            currentSkippedOrders = currentSkippedOrders.filter((o) => o !== order)
          }
        })

        currentSkippedOrders.push(...ordersToSkipFromThisCheckpoint)
      }
    })

    const finalSkippedOrders = Array.from(new Set(currentSkippedOrders))

    const titleGroups: any = {}
    const standaloneQuestions: any[] = []
    allQuestions.forEach((element, index) => {
      if (element.title && element.title.trim() !== '') {
        const groupKey = `${element.title}-${element.order}`
        if (!titleGroups[groupKey]) {
          titleGroups[groupKey] = {
            title: element.title,
            order: element.order,
            questions: [],
            indices: [],
          }
        }
        titleGroups[groupKey].questions.push({...element, originalIndex: index})
        titleGroups[groupKey].indices.push(index)
      } else {
        standaloneQuestions.push({...element, originalIndex: index})
      }
    })
    standaloneQuestions.sort((a: any, b: any) => (a.order || 0) - (b.order || 0))
    const sortedGroups = Object.values(titleGroups).sort(
      (a: any, b: any) => (a.order || 0) - (b.order || 0)
    )

    const combinedItems = [
      ...standaloneQuestions.map((q) => ({
        type: 'standalone',
        question: q,
        order: q.order || 0,
        originalOrder: q.order,
      })),
      ...sortedGroups.map((g: any) => ({type: 'group', ...g, originalOrder: g.order})),
    ]
    combinedItems.sort((a, b) => a.order - b.order)

    const numberedListForFlatArray = Array(allQuestions.length).fill(0)
    let finalQuestionNumber = 1

    combinedItems.forEach((item) => {
      const itemOrder = item.originalOrder
      const isCheckpoint = item.type === 'standalone' && item.question.type === 'checkpoint'
      const isVisible = !finalSkippedOrders.includes(itemOrder) || isCheckpoint

      if (isVisible) {
        const indicesToNumber: number[] =
          item.type === 'standalone'
            ? [item.question.originalIndex]
            : item.questions.map((q) => q.originalIndex)

        indicesToNumber.forEach((originalIndex) => {
          numberedListForFlatArray[originalIndex] = finalQuestionNumber
        })
        finalQuestionNumber++
      }
    })

    return {
      questionNumberList: numberedListForFlatArray,
      skippedQuestionsIndex: finalSkippedOrders,
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      const res = await getInterviewbyid(params.id)
      setInterviewName(res.interviewName)
      setProjectName(res.project.name)
      const fetchedData: QuestionData[] = res.questions
      setData(fetchedData)
      setBool(Array(fetchedData.length).fill(false))
      setLocationName(Array(fetchedData.length).fill(''))
      setReasonLocationName(Array(fetchedData.length).fill(''))

      const sortedCheckpoints = res.checkpoints?.sort((a, b) => a.index - b.index) || []
      setCheckpoints(sortedCheckpoints)
    }

    const fetchResponses = async () => {
      const res = await getResponseByInterviewAndAnswer(params.id, params.answerId)
      const responseQuestions = res?.questions || []
      setQuestions(responseQuestions)

      // Calculate initial question numbering based on loaded responses
      const {questionNumberList: initialNumberList, skippedQuestionsIndex: initialSkipped} =
        calculateQuestionDisplayInfo(data, checkpoints, responseQuestions)

      setQuestionNumberList(initialNumberList)
      setSkippedQuestionsIndex(initialSkipped)
    }

    if (params.id !== undefined) fetchData()
    if (params.answerId !== undefined && data.length > 0) fetchResponses()
  }, [params, data.length, checkpoints.length])

  useEffect(() => {
    const fetchCountries = async () => {
      const res = await getCountries()
      const temp = res.map((country: {name: {common: string}}) => ({
        label: country?.name?.common,
        value: country?.name?.common,
      }))
      dispatch(setCountries(temp))
    }
    if (countryLoading) fetchCountries()
  }, [countryLoading])

  const handleFormEdit = debounce(async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setSubmitting(true)

    const isFormValid = questions.every((item, idx) => {
      const elem = data[idx]
      if (!elem.required) return true

      const response = item.response?.[0]
      switch (item.type) {
        case 'text':
          return typeof response === 'string' && response.trim().length >= 3
        case 'number':
          return !isNaN(Number(response))
        case 'date':
        case 'time':
        case 'time-15':
        case 'time-30':
        case 'time-60':
        case 'country':
          return Boolean(response)
        case 'location':
          return (
            item.response.length > 0 &&
            item.coordinates &&
            item.coordinates.lat &&
            item.coordinates.lng
          )
        default:
          return item.response.length > 0
      }
    })

    if (!isFormValid) {
      setValidateInput(true)
      setSubmitting(false)
      await Swal.fire({
        title: 'Validation Error',
        text: 'Please fill in all required fields.',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#007bff',
      })
      return
    }

    const datares = {
      questions: questions.map((item, idx) => {
        return item.type === 'checkbox'
          ? {...item, response: item.response, question: removeAsterisk(item.question)}
          : {...item, question: removeAsterisk(item.question)}
      }),
    }

    const res = await editInterviewResponse(params.id, params.answerId, datares)

    if (res) {
      await Swal.fire({
        title: 'Success',
        text: 'Response updated successfully',
        icon: 'success',
        confirmButtonText: 'OK',
        confirmButtonColor: '#007bff',
      })
      navigate(`/reports/${params.id}`)
    }
    setSubmitting(false)
  }, 1000)

  const handleSelect = async (address: string, index: number) => {
    try {
      const results = await geocodeByAddress(address)
      const latLng = await getLatLng(results[0])
      setQuestions((prev) => {
        const updatedFormData = [...prev]
        updatedFormData[index] = {
          ...updatedFormData[index],
          response: [address],
          coordinates: {lat: latLng.lat, lng: latLng.lng},
        }
        return updatedFormData
      })
    } catch (error) {
      console.error('Error selecting location', error)
    }
  }

  const handleReasonSelect = async (address: string, index: number) => {
    try {
      setQuestions((prev) => {
        const updatedFormData = [...prev]
        updatedFormData[index] = {
          ...updatedFormData[index],
          reasonResponse: [address],
        }
        return updatedFormData
      })
    } catch (error) {
      console.error('Error selecting location', error)
    }
  }

  const handleInputChange = (index: number, value: any, type: string) => {
    setQuestions((prev) => {
      const updatedFormData = [...prev]
      updatedFormData[index] = {
        ...updatedFormData[index],
        response: type === 'text' ? [value] : [parseFloat(value)],
      }
      return updatedFormData
    })
  }

  const handleInputChangeReason = (index: number, value: any, type: string) => {
    setQuestions((prev) => {
      const updatedFormData = [...prev]
      updatedFormData[index] = {
        ...updatedFormData[index],
        reasonResponse: type === 'text' ? [value] : [parseFloat(value)],
      }
      return updatedFormData
    })
  }

  function handleCheckpointValueChange(
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
    index: number
  ) {
    const selectedOptionValue = e.target.value

    const newQuestionsState = questions.map((q, i) =>
      i === index ? {...q, response: [selectedOptionValue]} : q
    )

    const {questionNumberList: newNumberList, skippedQuestionsIndex: newSkippedIndices} =
      calculateQuestionDisplayInfo(data, checkpoints, newQuestionsState)

    setSkippedQuestionsIndex(newSkippedIndices)
    setQuestionNumberList(newNumberList)
    setQuestions(newQuestionsState)
  }

  return (
    <section>
      <div className='flex flex-col px-8 py-6'>
        <h2 className='mb-6 text-2lg font-bold capitalize'>{interviewName}</h2>
        <h3 className='mb-4 text-lg font-semibold capitalize'>{projectName}</h3>
        <div className='w-full rounded-lg card text-base md:mx-4'>
          <form id='kt_modal_add_user_form' className='form'>
            <div className='flex flex-col justify-around gap-4 p-4 text-gray-800'>
              {(() => {
                // Group questions by title and order, then add numbering
                const titleGroups: any = {}
                const standaloneQuestions = []

                // First pass: group by title and collect standalone questions
                data.forEach((element, index) => {
                  if (element.title && element.title.trim() !== '') {
                    const groupKey = `${element.title}-${element.order}`
                    if (!titleGroups[groupKey]) {
                      titleGroups[groupKey] = {
                        title: element.title,
                        order: element.order,
                        questions: [],
                        indices: [],
                      }
                    }
                    titleGroups[groupKey].questions.push({
                      ...element,
                      originalIndex: index,
                    })
                    titleGroups[groupKey].indices.push(index)
                  } else {
                    standaloneQuestions.push({
                      ...element,
                      originalIndex: index,
                    })
                  }
                })

                standaloneQuestions.sort((a: any, b: any) => (a.order || 0) - (b.order || 0))

                const sortedGroups = Object.values(titleGroups).sort(
                  (a: any, b: any) => (a.order || 0) - (b.order || 0)
                )

                sortedGroups.forEach((group: any) => {
                  group.questions.sort((a: any, b: any) => a.originalIndex - b.originalIndex)
                })

                const allItems = [
                  ...standaloneQuestions.map((q) => ({
                    type: 'standalone',
                    question: q,
                    order: q.order || 0,
                  })),
                  ...sortedGroups.map((g: any) => ({type: 'group', ...g})),
                ]

                allItems.sort((a, b) => (a.order || 0) - (b.order || 0))

                return allItems.map((item, groupIndex) => {
                  const itemOrder = item.type === 'standalone' ? item.question.order : item.order
                  const isSkipped = skippedQuestionsIndex.includes(itemOrder)

                  if (isSkipped) {
                    return null
                  }

                  let displayQuestionNumber = 0
                  if (item.type === 'standalone') {
                    displayQuestionNumber = questionNumberList[item.question.originalIndex]
                  } else {
                    const firstQuestionIndex = item.questions[0]?.originalIndex
                    if (firstQuestionIndex !== undefined) {
                      displayQuestionNumber = questionNumberList[firstQuestionIndex]
                    }
                  }

                  if (displayQuestionNumber === 0) {
                    return null
                  }

                  if (item.type === 'standalone') {
                    const element = item.question
                    const index = element.originalIndex

                    return (
                      <div key={`standalone-${groupIndex}`} className='question-container'>
                        <h2 className='text-xl font-bold mb-4 text-blue-600'>
                          Question {displayQuestionNumber}
                        </h2>
                        <div>
                          <p className=''>
                            <span dangerouslySetInnerHTML={{__html: parseBold(element.question)}} />{' '}
                            {element.required && <span className='text-red-600'>*</span>}
                          </p>
                          {element.type === 'checkpoint'
                            ? renderCheckpointQuestionInput(element, index)
                            : renderQuestionInput(element, index)}
                        </div>
                      </div>
                    )
                  } else {
                    // Group type
                    const visibleSubQuestions = item.questions.filter((q) => {
                      if (q.type === 'rank') return true
                      return true
                    })

                    if (visibleSubQuestions.length === 0) return null

                    return (
                      <div
                        key={`group-${groupIndex}`}
                        className='question-group-container border border-gray-300 rounded-lg p-4 bg-light'
                      >
                        <h2 className='text-xl font-bold mb-4 text-blue-600'>
                          Question {displayQuestionNumber}: {item.title}
                        </h2>
                        <div className='space-y-4'>
                          {item.questions.map((element, subIndex) => {
                            const isRank = element.type === 'rank'
                            const index = element.originalIndex

                            if (isRank) {
                              if (subIndex === 0) {
                                return renderRankQuestions(item.questions, displayQuestionNumber)
                              }
                              return (
                                <React.Fragment
                                  key={`sub-rank-spacer-${subIndex}`}
                                ></React.Fragment>
                              )
                            }

                            const isIndividualSkipped = skippedQuestionsIndex.includes(
                              element.order
                            )
                            if (isIndividualSkipped) return null

                            return (
                              <div
                                key={`sub-${subIndex}`}
                                className='sub-question ml-4 border-l-4 border-blue-200 pl-4'
                              >
                                <h4 className='text-md font-medium mb-2 text-gray-700'>
                                  {displayQuestionNumber}.{subIndex + 1}
                                </h4>
                                <div>
                                  <p className=''>
                                    <span
                                      dangerouslySetInnerHTML={{
                                        __html: parseBold(element.question),
                                      }}
                                    />{' '}
                                    {element.required && <span className='text-red-600'>*</span>}
                                  </p>
                                  {renderQuestionInput(element, index)}
                                </div>
                                <div className='separator separator-dashed border-gray-500 mt-6'></div>
                              </div>
                            )
                          })}
                        </div>
                      </div>
                    )
                  }
                })

                function renderQuestionInput(element, index) {
                  return (
                    <>
                      {element.type === 'text' && (
                        <div>
                          <input
                            type='text'
                            className='form-control form-control-solid mb-3 mb-lg-0'
                            placeholder={removeAsterisk(element.question)}
                            required={element.required}
                            value={questions[index]?.response?.[0] ?? ''}
                            onChange={(e) => handleInputChange(index, e.target.value, 'text')}
                          />
                          {element.required &&
                            validateInput &&
                            (questions[index].response?.[0] === undefined ||
                              questions[index].response[0]?.length < 3) && (
                              <div className='alert alert-danger mt-2' role='alert'>
                                Input cannot be less than 3!
                              </div>
                            )}
                        </div>
                      )}
                      {element.type === 'checkbox' && (
                        <div className='ml-2 flex flex-col gap-1'>
                          <div
                            className={element.options.length > 6 ? 'row' : 'flex flex-col gap-1'}
                          >
                            {element.options.map((currElem, idx) => (
                              <label
                                key={idx}
                                className={`form-check-label ${
                                  element.options.length > 5 ? 'col-md-6' : ''
                                }`}
                              >
                                <input
                                  type='checkbox'
                                  className='form-check-input me-3 mb-2 border-black'
                                  value={currElem}
                                  checked={questions[index].response.includes(currElem)}
                                  onChange={(e) =>
                                    setQuestions((prev) => {
                                      const updatedFormData = [...prev]
                                      if (e.target.checked) {
                                        updatedFormData[index] = {
                                          ...updatedFormData[index],
                                          response: [
                                            ...updatedFormData[index].response,
                                            e.target.value,
                                          ],
                                        }
                                      } else {
                                        updatedFormData[index] = {
                                          ...updatedFormData[index],
                                          response: updatedFormData[index].response.filter(
                                            (item) => item !== e.target.value
                                          ),
                                        }
                                      }
                                      return updatedFormData
                                    })
                                  }
                                />
                                {currElem}
                              </label>
                            ))}
                          </div>
                          {element.required &&
                            validateInput &&
                            questions[index].response.length < 1 && (
                              <div className='alert alert-danger mt-2' role='alert'>
                                This option is required
                              </div>
                            )}
                        </div>
                      )}
                      {element.type === 'multiple' && (
                        <div className='ml-2 flex flex-col gap-1'>
                          <div
                            className={element.options.length > 6 ? 'row' : 'flex flex-col gap-1'}
                          >
                            {element.options.map((currElem, idx) => (
                              <label
                                key={idx}
                                className={`form-check-label ${
                                  element.options.length > 5 ? 'col-md-6' : ''
                                }`}
                              >
                                <input
                                  type='radio'
                                  name={`radio${index}`}
                                  className='form-check-input me-3 mb-2 border-black'
                                  required={element.required}
                                  value={currElem}
                                  onChange={(e) =>
                                    setQuestions((prev) => {
                                      const updatedFormData = [...prev]
                                      updatedFormData[index] = {
                                        ...updatedFormData[index],
                                        response: [e.target.value],
                                      }
                                      return updatedFormData
                                    })
                                  }
                                />
                                {currElem}
                              </label>
                            ))}
                          </div>
                          {element.required &&
                            validateInput &&
                            questions[index].response.length < 1 && (
                              <div className='alert alert-danger mt-2' role='alert'>
                                This option is required
                              </div>
                            )}
                        </div>
                      )}
                      {element.type === 'dropdown' && (
                        <div>
                          <select
                            className='form-select form-select-sm form-select-solid mb-2'
                            data-control='select2'
                            data-placeholder='Latest'
                            data-hide-search='true'
                            required={element.required}
                            defaultValue=''
                            onChange={(e) =>
                              setQuestions((prev) => {
                                const updatedFormData = [...prev]
                                updatedFormData[index] = {
                                  ...updatedFormData[index],
                                  response: [e.target.value],
                                }
                                return updatedFormData
                              })
                            }
                          >
                            <option value=''>Select</option>
                            {element.options.map((currElem, idx) => {
                              return (
                                <option key={idx} value={currElem}>
                                  {currElem}
                                </option>
                              )
                            })}
                          </select>
                          {element.required &&
                            validateInput &&
                            questions[index].response.length < 1 && (
                              <div className='alert alert-danger mt-2' role='alert'>
                                This option is required
                              </div>
                            )}
                        </div>
                      )}
                      {element.type === 'number' && (
                        <div className='mb-3'>
                          <input
                            type='number'
                            className='form-control form-control-solid mb-3 mb-lg-0'
                            placeholder={removeAsterisk(element.question)}
                            required={element.required}
                            value={questions[index].response[0] ?? ''}
                            onChange={(e) => handleInputChange(index, e.target.value, 'number')}
                          />
                          {element.required &&
                            validateInput &&
                            (questions[index].response[0] === '' ||
                              isNaN(questions[index].response[0])) && (
                              <div className='alert alert-danger mt-2' role='alert'>
                                Input must be a valid number!
                              </div>
                            )}
                        </div>
                      )}
                      {element.type === 'date' && (
                        <div>
                          <Flatpickr
                            className='form-control form-control-solid my-3'
                            placeholder={removeAsterisk(element.question)}
                            required={element.required}
                            options={{
                              dateFormat: 'd-m-Y',
                            }}
                            value={
                              questions[index].response
                                ? new Date(questions[index].response[0])
                                : ''
                            }
                            onChange={(date) =>
                              setQuestions((prev) => {
                                const updatedFormData = [...prev]
                                updatedFormData[index] = {
                                  ...updatedFormData[index],
                                  response: [new Date(date).toISOString()],
                                }
                                return updatedFormData
                              })
                            }
                          />
                          {element.required &&
                            validateInput &&
                            questions[index].response.length < 1 && (
                              <div className='alert alert-danger mt-2' role='alert'>
                                Date is required
                              </div>
                            )}
                        </div>
                      )}
                      {element.type === 'time' && (
                        <div>
                          <Flatpickr
                            className='form-control form-control-solid my-3'
                            placeholder={removeAsterisk(element.question)}
                            required={element.required}
                            options={{
                              enableTime: true,
                              noCalendar: true,
                              dateFormat: 'H:i',
                              time_24hr: true,
                            }}
                            value={
                              questions[index].response
                                ? new Date(questions[index].response[0])
                                : ''
                            }
                            onChange={(date) =>
                              setQuestions((prev) => {
                                const updatedFormData = [...prev]
                                updatedFormData[index] = {
                                  ...updatedFormData[index],
                                  response: [new Date(date).toISOString()],
                                }
                                return updatedFormData
                              })
                            }
                          />
                          {element.required &&
                            validateInput &&
                            questions[index].response.length < 1 && (
                              <div className='alert alert-danger mt-2' role='alert'>
                                Time is required
                              </div>
                            )}
                        </div>
                      )}

                      {element.type === 'time-15' && (
                        <div>
                          <TimeIntervals
                            interval={15}
                            index={index}
                            questions={questions}
                            setQuestions={setQuestions}
                          />
                          {element.required &&
                            validateInput &&
                            questions[index].response.length < 1 && (
                              <div className='alert alert-danger mt-2' role='alert'>
                                Time is required
                              </div>
                            )}
                        </div>
                      )}

                      {element.type === 'time-30' && (
                        <div>
                          <TimeIntervals
                            interval={30}
                            index={index}
                            questions={questions}
                            setQuestions={setQuestions}
                          />
                          {element.required &&
                            validateInput &&
                            questions[index].response.length < 1 && (
                              <div className='alert alert-danger mt-2' role='alert'>
                                Time is required
                              </div>
                            )}
                        </div>
                      )}

                      {element.type === 'time-60' && (
                        <div>
                          <TimeIntervals
                            interval={60}
                            index={index}
                            questions={questions}
                            setQuestions={setQuestions}
                          />
                          {element.required &&
                            validateInput &&
                            questions[index].response.length < 1 && (
                              <div className='alert alert-danger mt-2' role='alert'>
                                Time is required
                              </div>
                            )}
                        </div>
                      )}

                      {element.type === 'country' && (
                        <div>
                          <Select
                            options={countries}
                            onChange={(e) =>
                              setQuestions((prev) => {
                                const updatedFormData = [...prev]
                                updatedFormData[index] = {
                                  ...updatedFormData[index],
                                  response: [e?.value || ''],
                                }
                                return updatedFormData
                              })
                            }
                            isClearable
                            filterOption={(option, inputValue) =>
                              option.label.toLowerCase().startsWith(inputValue.toLowerCase())
                            }
                          />
                          {element.required &&
                            validateInput &&
                            questions[index].response.length < 1 && (
                              <div className='alert alert-danger mt-2' role='alert'>
                                Country is required
                              </div>
                            )}
                        </div>
                      )}

                      {element.type === 'location' && (
                        <div>
                          <input
                            type='text'
                            className='form-control form-control-solid mb-3 mb-lg-0'
                            placeholder={removeAsterisk(element.question)}
                            required={element.required}
                            value={questions[index].response[0] ?? ''}
                            onChange={(e) => handleInputChange(index, e.target.value, 'text')}
                          />
                          {element.required &&
                            validateInput &&
                            questions[index].response[0]?.length < 3 && (
                              <div className='alert alert-danger mt-2' role='alert'>
                                Input cannot be less than 3!
                              </div>
                            )}

                          <div className='d-flex gap-2 my-3'>
                            <PlacesAutocomplete
                              value={locationName[index]}
                              onChange={(value) =>
                                setLocationName((prev) => {
                                  const updatedLocationName = [...prev]
                                  updatedLocationName[index] = value
                                  return updatedLocationName
                                })
                              }
                              onSelect={(value) => handleSelect(value, index)}
                              searchOptions={{
                                location: new google.maps.LatLng(25.276987, 55.296249),
                                radius: 300000,
                                componentRestrictions: {country: 'ae'},
                              }}
                            >
                              {({getInputProps, suggestions, getSuggestionItemProps, loading}) => (
                                <div className='flex-grow-1'>
                                  <input
                                    {...getInputProps({
                                      placeholder: 'Search Location...',
                                      className:
                                        'location-search-input form-control form-control-solid',
                                    })}
                                  />
                                  <div className='autocomplete-dropdown-container'>
                                    {loading && <div>Loading...</div>}
                                    {suggestions.map((suggestion) => (
                                      <div
                                        {...getSuggestionItemProps(suggestion, {
                                          className: suggestion.active
                                            ? 'suggestion-item--active'
                                            : 'suggestion-item',
                                        })}
                                        key={suggestion.placeId}
                                        className='cursor-pointer form-control form-control-solid'
                                      >
                                        <span>{suggestion.description}</span>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )}
                            </PlacesAutocomplete>

                            <button
                              type='button'
                              className='btn btn-light-primary'
                              onClick={() => {
                                setBool((prev) => {
                                  const updatedBool = Array(prev.length).fill(false)
                                  updatedBool[index] = true
                                  return updatedBool
                                })
                                setSelectedIndex(index)
                                setCoordinates(questions[index].coordinates)
                                if (questions[index].coordinates) {
                                  setCenter({
                                    lat: questions[index].coordinates.lat,
                                    lng: questions[index].coordinates.lng,
                                  })
                                }
                                setShowModal(true)
                              }}
                              title='Choose Location'
                            >
                              <KTIcon iconName='map' className='fs-2' />
                            </button>
                          </div>

                          {questions[index].coordinates && (
                            <div>
                              <p>Latitude: {questions[index].coordinates.lat}</p>
                              <p>Longitude: {questions[index].coordinates.lng}</p>
                            </div>
                          )}

                          {element.required &&
                            validateInput &&
                            (!questions[index].response ||
                              questions[index].response.length === 0) && (
                              <div className='alert alert-danger mt-2' role='alert'>
                                At least one location is required!
                              </div>
                            )}
                          {element.required &&
                            validateInput &&
                            (!questions[index].coordinates ||
                              questions[index].coordinates.length === 0) && (
                              <div className='alert alert-danger mt-2' role='alert'>
                                At least one location is required!
                              </div>
                            )}
                        </div>
                      )}

                      {element.other && (
                        <div className='mb-2'>
                          <input
                            type='text'
                            className='form-control form-control-solid mb-3 mb-lg-0'
                            placeholder='other (Please Specify)'
                            onChange={(e) =>
                              setQuestions((prev) => {
                                const updatedFormData = [...prev]
                                updatedFormData[index] = {
                                  ...updatedFormData[index],
                                  response: [e.target.value],
                                }
                                return updatedFormData
                              })
                            }
                          />
                          {element.required &&
                            validateInput &&
                            (questions[index].response.length < 1 ||
                              questions[index].response[0]?.length < 1) && (
                              <div className='alert alert-danger mt-2' role='alert'>
                                Input cannot be less than 3!
                              </div>
                            )}
                        </div>
                      )}
                      {element.comment && (
                        <div>
                          <input
                            type='text'
                            className='form-control form-control-solid mb-3 mb-lg-0'
                            placeholder='Comment'
                            value={questions[index].comment}
                            onChange={(e) =>
                              setQuestions((prev) => {
                                const updatedFormData = [...prev]
                                updatedFormData[index] = {
                                  ...updatedFormData[index],
                                  comment: e.target.value,
                                }
                                return updatedFormData
                              })
                            }
                          />
                        </div>
                      )}
                    </>
                  )
                }

                function renderCheckpointQuestionInput(element: QuestionData, index: number) {
                  const currentCheckpoint = checkpoints.find((cp) => cp.index === element.order - 1)
                  const optionsToRender = currentCheckpoint ? currentCheckpoint.sectionOptions : []

                  return (
                    <div className='ml-2 flex flex-col gap-1'>
                      <div className={element.options.length > 6 ? 'row' : 'flex flex-col gap-1'}>
                        {optionsToRender.map((currElem, idx) => (
                          <label
                            key={idx}
                            className={`form-check-label ${
                              element.options.length > 5 ? 'col-md-6' : ''
                            }`}
                          >
                            <input
                              type='radio'
                              name={`radio${index}`}
                              className='form-check-input me-3 mb-2 border-black'
                              required={element.required}
                              value={currElem.option}
                              checked={questions[index]?.response?.[0] === currElem.option}
                              onChange={(e) =>
                                handleCheckpointValueChange(
                                  e as React.ChangeEvent<HTMLInputElement>,
                                  index
                                )
                              }
                            />
                            {currElem.option}
                          </label>
                        ))}
                        {element.required && validateInput && questions[index].response.length < 1 && (
                          <div className='alert alert-danger mt-2' role='alert'>
                            This option is required
                          </div>
                        )}
                      </div>
                    </div>
                  )
                }

                function renderRankQuestions(data, questionNumber) {
                  return (
                    <>
                      <div className='row'>
                        <div className='col-lg-6'></div>
                        <div className='col-lg-6 d-flex justify-evenly gap-1'>
                          {data?.[0]?.options?.map((option, index) => {
                            const words = option.split(' ')
                            return (
                              <p key={index} className='whitespace-normal'>
                                {words.length > 1
                                  ? words.map((word, wordIndex) => (
                                      <span key={wordIndex}>
                                        {word}
                                        {wordIndex < words.length - 1 && <br />}
                                      </span>
                                    ))
                                  : option}
                              </p>
                            )
                          })}
                        </div>
                      </div>
                      <div className={`${data?.length > 6 ? 'h-[500px] overflow-y-scroll' : ''}`}>
                        {data?.map((element, subIndex) => {
                          return (
                            <div
                              key={`sub-${subIndex}`}
                              className='sub-question ml-4 border-l-4 border-blue-200 pl-4 mb-10'
                            >
                              <div className='row'>
                                <div className='col-lg-6 d-flex gap-2 flex-wrap'>
                                  <h4 className='text-md font-medium mb-2 text-gray-700'>
                                    {questionNumber}.{subIndex + 1}
                                  </h4>
                                  <p className={element.required ? 'required' : ''}>
                                    <span
                                      dangerouslySetInnerHTML={{
                                        __html: parseBold(element.question),
                                      }}
                                    />
                                  </p>
                                </div>
                                <div className='col-lg-6 d-flex justify-evenly align-items-center gap-1'>
                                  {element?.options?.map((option, optIndex) => {
                                    return (
                                      <input
                                        type='radio'
                                        className='form-check-input mb-2 border-black'
                                        id={`radio-${optIndex}`}
                                        name={`question-${element.originalIndex}`}
                                        key={`radio-${optIndex}`}
                                        checked={
                                          questions[element.originalIndex]?.response?.[0] === option
                                        }
                                        onChange={(e) => {
                                          setQuestions((prev) => {
                                            const updatedFormData = [...prev]
                                            const idx = element.originalIndex
                                            const optionValue = option
                                            const isChecked = e.target.checked
                                            updatedFormData[idx] = {
                                              ...updatedFormData[idx],
                                              response: isChecked ? [optionValue] : [],
                                            }
                                            return updatedFormData
                                          })
                                        }}
                                      />
                                    )
                                  })}
                                </div>
                              </div>
                              <div className='separator separator-dashed border-gray-500 mt-6'></div>
                            </div>
                          )
                        })}
                      </div>
                    </>
                  )
                }
              })()}
            </div>
            <div className=''>
              <button
                type='button'
                onClick={handleFormEdit}
                disabled={submitting}
                className='btn btn-warning uppercase my-4 mx-4'
              >
                {submitting ? <Spinner animation='border' size='sm' /> : 'Edit'}
              </button>
            </div>
          </form>
        </div>
      </div>

      {showModal && (
        <Modal show={showModal} onHide={closeModal} size='lg' backdrop='static'>
          <Modal.Header closeButton>
            <Modal.Title>Choose your Location</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='card-body py-4'>
              <GoogleMap
                mapContainerStyle={mapContainerStyle}
                center={center}
                zoom={14}
                onClick={(e) => {
                  handleMapClick(e)
                }}
              >
                {coordinates && <Marker position={coordinates}></Marker>}
              </GoogleMap>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='primary' onClick={saveLocation}>
              Save
            </Button>
            <Button variant='danger' onClick={closeModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </section>
  )
}

export default EditInterviewQuestionaire
